import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import FetchLocalStorageDataByPath from './utils/helper/FetchLocalstorageDataByPath';

const PrivateRoute = ({ element, ...rest }) => {
  const [isFeatureActive, setIsFeatureActive] = useState({});
  const { path } = rest;
  const newPath = path.slice(1);
  const location = useLocation();

  const isAuthenticated = () => {
    let token = sessionStorage.getItem('authorizationToken');
    return token && token !== null;
  };
  useEffect(() => {
    getLocalStorageDataFunc();
  }, [path]);

  const getLocalStorageDataFunc = () => {
    try {
      const features = FetchLocalStorageDataByPath('system_config', 'features') ?? [];

      const foundFeature = features.find((item) => item.path_name === newPath);

      if (foundFeature) {
        setIsFeatureActive((prev) => ({
          ...prev,
          [newPath]: foundFeature.value,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const isAuth = isAuthenticated();

  if (!isAuth) {
    if (location?.pathname?.includes('buow') && location?.search?.includes('email')) {
      sessionStorage.setItem('redirectTo', location.pathname);
    }
    return <Navigate to="/login" />;
  }

  if (isFeatureActive.hasOwnProperty(newPath)) {
    return isFeatureActive[newPath] ? element : <Navigate to="/inbasketpage" />;
  }

  return element;
};

export default PrivateRoute;
